export const config = {
isChartJsEnabled: true
}